/**
 * SubscriptionProvider - Context provider for subscription state
 *
 * Wrap your app with this provider to enable useSubscription hook.
 */

import { ReactNode } from 'react';
import { SubscriptionContext, useSubscriptionState } from '../hooks/useSubscription';

interface SubscriptionProviderProps {
  children: ReactNode;
}

export function SubscriptionProvider({ children }: SubscriptionProviderProps) {
  const subscriptionState = useSubscriptionState();

  return (
    <SubscriptionContext.Provider value={subscriptionState}>
      {children}
    </SubscriptionContext.Provider>
  );
}
